export default "__VITE_ASSET__BBfs2x90__"